import { useContext, useEffect, useState } from 'react';
import { Container, Text, Title } from './Styled'
import { AppContext } from '../../contexts/AppContext';
import './Welcome.css';


const WelcomeDetails = () => {
  {/*
  const { defaultValues } = useContext(AppContext);
  const [items, setItems] = useState<any[]>([]);

  useEffect(() => {
    if (defaultValues) {
      const nComponents = defaultValues["home"]["titles"].length;
  
      const newItems = [];
      for (let i = 0; i < nComponents; ++i) {
        newItems.push({
          title: defaultValues["home"]["titles"][i],
          description: defaultValues["home"]["descriptions"][i]
        });
      }
      setItems(newItems);
    }
  }, [defaultValues]);


  return (
    <Container>
      {items.map((item, idx) => {
        return (
          <div key={"div-" + idx.toString()}>
            <Title key={"title-" + idx.toString()}>{item["title"]}</Title>
            <Text key={"text-" + idx.toString()}>{item["description"]}</Text>
          </div>
        );
      })}
    </Container>
    */}
  return (
    <Container className="contenu-demie-page">
      <Text style={{ fontSize: '2em', fontWeight: '400', marginBottom: '0.5em', textAlign: 'left', color: '#22588A' }}>
        EcoConfort vous invite à expérimenter le quotidien d’un foyer : optimisez votre consommation d’énergie tout en maintenant un niveau de confort qui évolue selon vos décisions.
      </Text>
    </Container>
  );
}


export default WelcomeDetails;
